import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const VirtualConnectionTableLineageCountsFragmentGql: DocumentNode = gql`
fragment VirtualConnectionTableLineageCountsFragment on VirtualConnectionTable {
  unfilteredColumnsConnection: columnsConnection {
    totalCount
  }
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
`;
